// src/components/Navbar.jsx

import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const PORTAL_URL = "https://portal.chaotik.org";

const navItems = [
  { name: "Main", id: "intro" },
  { name: "Structure", id: "structure" },
  { name: "Fleet", id: "fleet" },
  { name: "Media", id: "media" },
  { name: "Join Us", path: "/apply", highlight: true },
  { name: "Code of Conduct", path: "/code-of-conduct" },
  { name: "Blog", path: "/blog" },
  { name: "Discord", external: "https://discord.gg/CHAOTIK" },
  { name: "Member Access", external: PORTAL_URL },
];

export default function Navbar() {
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
      setIsOpen(false);
    }, [location]);

  return (
    <>
      {/* Load the Bebas Neue font */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link
        rel="preconnect"
        href="https://fonts.gstatic.com"
        crossOrigin="true"
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap"
        rel="stylesheet"
      />

      <nav className="bg-[#96000b] h-[64px] sm:h-[70px] md:h-[76px] lg:h-[82px] shadow-md z-50 sticky top-0 overflow-x-clip">
        <div className="h-full px-3 sm:px-4 md:px-8 lg:px-10 max-w-screen-2xl mx-auto flex items-center justify-center relative">
          {/* Desktop Nav */}
          <ul className="hidden lg:flex absolute left-1/2 transform -translate-x-1/2 justify-center items-center h-full w-full max-w-[min(96vw,1400px)] gap-3 xl:gap-6 2xl:gap-8 text-[clamp(1rem,2vw,2.6rem)] font-bebas tracking-[0.09em] uppercase whitespace-nowrap">
            {navItems.map((item) => (
              <li key={item.name}>
                {item.external ? (
                  <a
                    href={item.external}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition duration-200 px-1 text-black hover:text-white"
                    style={{ fontFamily: "'Bebas Neue', sans-serif" }}
                  >
                    {item.name}
                  </a>
                ) : item.path ? (
                  <Link
                    to={item.path}
                    className={`transition duration-200 px-1 text-black hover:text-white ${
                      item.highlight ? "animate-pulseColor" : ""
                    }`}
                    style={{ fontFamily: "'Bebas Neue', sans-serif" }}
                  >
                    {item.name}
                  </Link>
                ) : (
                  <Link
                    to={`/#${item.id}`}
                    className="transition duration-200 px-1 text-black hover:text-white"
                    style={{ fontFamily: "'Bebas Neue', sans-serif" }}
                  >
                    {item.name}
                  </Link>
                )}
              </li>
            ))}
          </ul>

            {/* Mobile Hamburger */}
            <div className="lg:hidden z-50 w-full flex items-center justify-center h-full">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="text-black text-4xl focus:outline-none"
            >
              {isOpen ? "✕" : "☰"}
            </button>
          </div>
        </div>

        {/* Mobile Nav */}
        <div
          className={`transition-all duration-500 ease-in-out overflow-hidden lg:hidden ${
            isOpen ? "max-h-[500px] translate-y-0" : "max-h-0 -translate-y-10"
          }`}
        >
          <ul className="flex flex-col items-center bg-[#96000b] py-6 space-y-4 text-2xl font-bebas tracking-wider uppercase">
            {navItems.map((item) => (
              <li key={item.name}>
                {item.external ? (
                  <a
                    href={item.external}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition duration-200 px-4 py-2 rounded-md text-black hover:text-white"
                    style={{ fontFamily: "'Bebas Neue', sans-serif" }}
                    onClick={() => setIsOpen(false)}
                  >
                    {item.name}
                  </a>
                ) : item.path ? (
                  <Link
                    to={item.path}
                    onClick={() => setIsOpen(false)}
                    className={`transition duration-200 px-4 py-2 rounded-md text-black hover:text-white ${
                      item.highlight ? "animate-pulseColor" : ""
                    }`}
                    style={{ fontFamily: "'Bebas Neue', sans-serif" }}
                  >
                    {item.name}
                  </Link>
                ) : (
                  <Link
                    to={`/#${item.id}`}
                    onClick={() => setIsOpen(false)}
                    className="transition duration-200 px-4 py-2 rounded-md text-black hover:text-white"
                    style={{ fontFamily: "'Bebas Neue', sans-serif" }}
                  >
                    {item.name}
                  </Link>
                )}
              </li>
            ))}
          </ul>
          </div>
        </nav>
      </>
    );
  }
